import { useApi } from '@/composables/use-api'
import type { MetadataVisibility } from '../metadata/types'

export async function fetchInitialPermissions() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.getInitialPermission()
  return data
}

export async function fetchReviewers(visibility?: MetadataVisibility) {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.getReviewers({ visibility })
  return data
}

export async function fetchEditors() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.getEditors()
  return data
}

export async function fetchAssignees() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.getAssignees()
  return data
}

export async function fetchEmployeeGroups() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.getEmployeeGroups()
  return data
}

export async function addFavorite(email: string) {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.addFavorite({ email })
  return data
}

export async function removeFavorite(email: string) {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.users.removeFavorite({ email })
  return data
}
